import { FormHelperText, Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFundraiserContext } from 'src/shared/contexts/fundraiserContext';

export const FundraiserFilterDatePicker = () => {
  const { t } = useTranslation();
  const { fundraisingDistributionStorageSearchFilter, setFundraisingDistributionStorageSearchFilter } = useFundraiserContext();

  const [toDateError, setToDateError] = useState('');

  const validateDates = (
    fromDate: string | number | Date | dayjs.Dayjs | null | undefined,
    toDate: string | number | Date | dayjs.Dayjs | null | undefined,
  ) => {
    if (toDate && fromDate) {
      const from = dayjs(fromDate);
      const to = dayjs(toDate);
      if (dayjs(to).isBefore(from)) {
        setToDateError(t('fundraiser:toDateBeforeFromDate'));
        return false;
      }
      if (dayjs(to).isSame(from)) {
        setToDateError(t('fundraiser:toDateEqualFromDate'));
        return false;
      }
    }
    setToDateError('');
    return true;
  };

  const handleFromDateChange = (newDate) => {
    setFundraisingDistributionStorageSearchFilter((prev) => {
      const updatedFilter = { ...prev, start: newDate };
      validateDates(newDate, prev.end);
      return updatedFilter;
    });
  };

  const handleToDateChange = (newDate) => {
    setFundraisingDistributionStorageSearchFilter((prev) => {
      const updatedFilter = { ...prev, end: newDate };
      if (validateDates(prev.start, newDate)) {
        return updatedFilter;
      }
      return prev;
    });
  };

  return (
    <>
      <Grid item xs={12} lg={3}>
        <DatePicker
          value={dayjs(fundraisingDistributionStorageSearchFilter.start)}
          format='YYYY-MM-DD'
          displayWeekNumber
          label={t('fundraiser:timeFrom')}
          slotProps={{ textField: { size: 'small', fullWidth: true, InputLabelProps: { shrink: true } } }}
          onChange={handleFromDateChange}
          slots={{
            textField: TextField,
          }}
        />
      </Grid>

      <Grid item xs={12} lg={3}>
        <DatePicker
          value={dayjs(fundraisingDistributionStorageSearchFilter.end)}
          format='YYYY-MM-DD'
          displayWeekNumber
          label={t('fundraiser:timeTo')}
          slotProps={{ textField: { size: 'small', fullWidth: true, InputLabelProps: { shrink: true }, error: Boolean(toDateError) } }}
          onChange={handleToDateChange}
          slots={{
            textField: TextField,
          }}
        />
        {toDateError && <FormHelperText error>{toDateError}</FormHelperText>}
      </Grid>
    </>
  );
};
